// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3VeN4","content":"GlobalSearch_content__ZC3wM"};